import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export default function asColumns(buttons) {
  var nColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  var columns = _toConsumableArray(Array(nColumns)).map(function () {
    return [];
  });

  buttons.forEach(function (button, index) {
    var columnIndex = Math.floor(index / (buttons.length / nColumns));
    columns[columnIndex].push(button);
  });
  return columns;
}